import * as types from '../constants/action-types';
export const initDokbot = (payload) => ({
    type: types.INIT_DOKBOT,
    payload,
});
